<script>
	import Icon from "../icons/Icon.svelte";

	export let settlementHistory = [];
	export let isLoadingHistory = false;
	export let formatCurrency = (val) => Number(val || 0).toFixed(2).replace(".", ",");

	export let onReloadHistory = () => {};
</script>

<div class="history-panel">
	<div class="panel-header-row">
		<div class="panel-header-titles">
			<h3>Histórico de Fechamentos Realizados</h3>
			<p>Consultas e registros consolidados de turnos quitados com os motoboys</p>
		</div>
		<button type="button" class="btn-refresh" on:click={onReloadHistory} disabled={isLoadingHistory}>
			<Icon name="refresh" size={14} />
			<span>{isLoadingHistory ? 'Atualizando...' : 'Atualizar Histórico'}</span>
		</button>
	</div>

	{#if isLoadingHistory}
		<div class="loading-state">
			<div class="loading-spinner"></div>
			<span>Carregando histórico de fechamentos...</span>
		</div>
	{:else if settlementHistory.length === 0}
		<div class="empty-state-box">
			<div class="empty-state-icon"><Icon name="file-text" size={32} /></div>
			<h3>Nenhum fechamento registrado</h3>
			<p>Quando os turnos dos entregadores forem concluídos e salvos, eles aparecerão aqui como extrato de auditoria.</p>
		</div>
	{:else}
		<div class="table-container">
			<table class="modern-table">
				<thead>
					<tr>
						<th>Data do Fechamento</th>
						<th>Entregador</th>
						<th>Veículo</th>
						<th>Entregas</th>
						<th>Taxas Ganhas</th>
						<th>Dinheiro Rua</th>
						<th>Saldo Acertado</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{#each settlementHistory as h (h.id || h.settlement_date)}
						<tr>
							<td><strong>{h.settlement_date ? new Date((String(h.settlement_date).slice(0, 10)) + 'T12:00:00').toLocaleDateString('pt-BR') : '-'}</strong></td>
							<td><strong>{h.courier_name}</strong></td>
							<td>
								<span class="vehicle-pill-sub">
									{h.vehicle_type} {h.plate ? `(${h.plate})` : ''}
								</span>
							</td>
							<td><span class="badge-deliveries">{h.total_deliveries} entregas</span></td>
							<td><span class="text-orange">R$ {formatCurrency(h.total_fees)}</span></td>
							<td><span class="text-blue">R$ {formatCurrency(h.total_cash_collected)}</span></td>
							<td>
								<strong class={h.net_balance > 0 ? 'text-green' : h.net_balance < 0 ? 'text-orange' : ''}>
									{h.net_balance > 0 ? `Motoboy repassou R$ ${formatCurrency(h.net_balance)}` : h.net_balance < 0 ? `Loja pagou R$ ${formatCurrency(Math.abs(h.net_balance))}` : 'Quitado'}
								</strong>
							</td>
							<td><span class="status-pill available"><span class="dot"></span> Quitado</span></td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>
	{/if}
</div>

<style>
	.history-panel {
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-lg, 16px);
		padding: 24px;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.panel-header-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 16px;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
	}

	.panel-header-titles h3 {
		margin: 0 0 4px 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.panel-header-titles p {
		margin: 0;
		font-size: 13px;
		color: var(--text-secondary, #64748B);
	}

	.btn-refresh {
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #CBD5E1);
		padding: 9px 16px;
		border-radius: var(--radius-md, 8px);
		font-size: 13px;
		font-weight: 700;
		color: var(--text-primary, #1E293B);
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: all 0.15s ease;
	}

	.btn-refresh:hover:not(:disabled) {
		background: var(--neutral-surface-hover, #F8FAFC);
		border-color: var(--neutral-border-strong, #94A3B8);
	}

	.btn-refresh:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.vehicle-pill-sub {
		background: #F1F5F9;
		padding: 3px 8px;
		border-radius: 6px;
		font-size: 12px;
		color: var(--text-secondary, #475569);
	}

	.badge-deliveries {
		background: #EFF6FF;
		color: #1D4ED8;
		font-size: 11.5px;
		font-weight: 700;
		padding: 2px 8px;
		border-radius: 6px;
	}

	.table-container {
		overflow-x: auto;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-md, 10px);
	}

	.modern-table {
		width: 100%;
		border-collapse: collapse;
		text-align: left;
		font-size: 13px;
		background: #FFFFFF;
	}

	.modern-table th {
		padding: 12px 16px;
		background: #F8FAFC;
		color: var(--text-secondary, #475569);
		font-weight: 700;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
		font-size: 11.5px;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	.modern-table td {
		padding: 14px 16px;
		border-bottom: 1px solid var(--neutral-border-subtle, #F1F5F9);
		color: var(--text-primary, #0F172A);
		vertical-align: middle;
	}

	.modern-table tbody tr:hover {
		background: #FAFAFA;
	}

	.status-pill {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 4px 10px;
		border-radius: 9999px;
		font-size: 11.5px;
		font-weight: 700;
	}

	.status-pill.available {
		background: #DCFCE7;
		color: #166534;
		border: 1px solid #BBF7D0;
	}

	.status-pill .dot {
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #16A34A;
	}

	.text-green { color: #16A34A !important; }
	.text-blue { color: #2563EB !important; }
	.text-orange { color: #EA580C !important; }

	.loading-state, .empty-state-box {
		padding: 48px 24px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	.empty-state-icon {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		background: #F1F5F9;
		color: #94A3B8;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 4px;
	}

	.empty-state-box h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.empty-state-box p {
		margin: 0;
		font-size: 13.5px;
		color: var(--text-secondary, #64748B);
		max-width: 380px;
	}

	.loading-spinner {
		width: 32px;
		height: 32px;
		border: 3px solid var(--neutral-border, #E2E8F0);
		border-top-color: var(--brand-primary, #FF6A00);
		border-radius: 50%;
		animation: spin 0.8s linear infinite;
	}

	@keyframes spin {
		to { transform: rotate(360deg); }
	}
</style>
